import React from 'react';
import { CONSTANTS } from '../../data';
import { ASSETS } from '../../assetManifest';
import { sounds } from '../../systems/AudioSystem';
import type { AssetsSchema } from '../../assetManifestTypes';

interface MenuScreenProps {
  onStartNewGame: () => void;
  onContinueGame: () => void;
  onShowInstructions: () => void;
  onShowCredits: () => void;
  hasSaveData: boolean;
}

export const MenuScreen: React.FC<MenuScreenProps> = ({
  onStartNewGame,
  onContinueGame,
  onShowInstructions,
  onShowCredits,
  hasSaveData
}) => {
  const typedAssets = ASSETS as AssetsSchema;
  const backgroundAsset = typedAssets.backgrounds?.main_menu_neural_network;
  const logoAsset = typedAssets.other?.consciousness_craft_logo;

  return (
    <div
      className="menu-screen"
      style={{
        backgroundImage: backgroundAsset ? `url(${backgroundAsset.path})` : undefined,
      }}
    >
      {logoAsset && <img src={logoAsset.path} alt={CONSTANTS.MAIN_MENU.title} id="game-logo" />}
      <div className="menu-subtitle">{CONSTANTS.MAIN_MENU.subtitle}</div>
      <div className="flex flex-col items-center">
        {hasSaveData && (
          <button 
            className="menu-button" 
            onClick={onContinueGame}
            onMouseEnter={() => sounds.menuHover()}
          >
            {CONSTANTS.MAIN_MENU.continueButtonText}
          </button>
        )}
        <button 
          id="start-btn" 
          className="menu-button" 
          onClick={onStartNewGame}
          onMouseEnter={() => sounds.menuHover()}
        >
          {hasSaveData ? CONSTANTS.MAIN_MENU.newGameButtonText : CONSTANTS.MAIN_MENU.startButtonText}
        </button>
        <button 
          id="how-to-play-btn" 
          className="menu-button" 
          onClick={onShowInstructions}
          onMouseEnter={() => sounds.menuHover()}
        >
          {CONSTANTS.MAIN_MENU.howToPlayButtonText}
        </button>
        <button 
          id="credits-btn" 
          className="menu-button" 
          onClick={onShowCredits}
          onMouseEnter={() => sounds.menuHover()}
        >
          {CONSTANTS.MAIN_MENU.creditsButtonText}
        </button>
      </div>
    </div>
  );
};
